module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-edit.62747312.webp";